import {Button, IconButton} from "@mui/material";
import {FiPlus, FiTrash2} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import Window from "../components/Window/Window";
import {rolesColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import {useEffect} from "react";

const Roles = () => {
  const navigate = useNavigate();
  const {data, loading, list, remove} = useApiRequest("/roles");

  useEffect(() => {
    list();
    // eslint-disable-next-line
  }, []);

  const handleRoleClick = (role) => {
    if (!role?.id) {
      console.error("Error: No se encuentra el rol");
      return;
    }
    navigate(`/role-form`, {state: {id: role?.id}});
  };

  const handleRowDelete = async (id) => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este rol?");
    if (confirmDelete) {
      try {
        await remove(id);
        list();
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
      }
    }
  };

  const columns = [
    ...rolesColumns,
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            aria-label="delete"
            color="secondary"
            onClick={(e) => {
              e.stopPropagation();
              handleRowDelete(params.row.id);
            }}
          >
            <FiTrash2 />
          </IconButton>
        );
      }
    }
  ];

  return (
    <Window title={"Roles"}>
      {loading ? (
        <div style={{textAlign: "center", padding: "20px"}}>
          <span style={{fontSize: "18px", color: "#666"}}>Cargando...</span>
        </div>
      ) : (
        <ListView
          columns={columns}
          data={data}
          loading={loading}
          onRowClick={handleRoleClick}
          TopRigthButtons={
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              onClick={() => {
                navigate(`/role-form`);
              }}
            >
              Nuevo Rol
            </Button>
          }
        />
      )}
    </Window>
  );
};

export default Roles;
